export default __webpack_public_path__ + "static/media/ProximaNova-BoldIt.13d35d20.otf";